import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CropComponent } from './crop.component.js';
import { AppFlexModule } from '../flex/index.js';
import { ButtonModule } from '../buttons/index.js';
import { LoaderModule } from '../loader/loader.module.js';
import { ImageCropperComponent } from 'ngx-image-cropper';

@NgModule({
	declarations: [CropComponent],
	exports: [CropComponent],
	imports: [CommonModule, AppFlexModule, ButtonModule, LoaderModule, ImageCropperComponent]
})
export class CropModule {}
